import { AlertTriangle, Eye } from "lucide-react";

const HINTS = {
  dissociation: "Grounding exercises and sensory anchors may help; consider checking in about safety and triggers.",
  shutdown: "Low-demand days: tiny, achievable steps and reassurance that rest counts.",
  anxiety: "Consider a breathing or grounding read, and easing habit goals this week.",
  stress: "Ask what's piling up; a paused habit or lowered goal may protect momentum.",
  mood: "Persistent low mood — worth a direct check-in at your next session.",
  hope: "Low hope for several days — worth a warm, direct check-in.",
  sleep: "Sleep has been poor for days; sleep hygiene reads or a bedtime reminder could help.",
  panic: "Repeated panic attacks — review coping plan and the SOS tools together.",
};

export function ClientAlerts({ alerts, struggle }) {
  if (!alerts?.length && !(struggle?.level > 0)) return null;
  return (
    <div className="rounded-3xl p-5 border border-amber-300 bg-amber-50/70" data-testid="client-alerts">
      <div className="flex items-center gap-2 mb-2">
        <Eye className="w-4 h-4 text-amber-800" />
        <h3 className="font-display font-bold text-stone-900">Worth a look</h3>
        <span className="text-[10px] text-stone-500 ml-1">from recent check-ins — a gentle flag, not a diagnosis</span>
      </div>
      {struggle?.level > 0 && (
        <p className="text-sm text-stone-800 mb-2" data-testid="alert-struggle">
          Wellbeing is trending <span className="font-semibold">{struggle.level === 2 ? "much worse" : "worse"}</span> than the previous weeks
          (distress {struggle.recent_avg}/10{struggle.baseline_avg != null ? ` vs ${struggle.baseline_avg} before` : ""}).
          {struggle.drivers?.length > 0 && <> Driven by: {struggle.drivers.map((d) => `${d.label.toLowerCase()} ${d.avg}`).join(", ")}.</>}
          {" "}Habit check-ins during this stretch earn a Resilience bonus automatically.
        </p>
      )}
      <ul className="space-y-2">
        {alerts.map((a) => (
          <li key={a.key} className="flex items-start gap-2 text-sm" data-testid={`alert-${a.key}`}>
            <AlertTriangle className={`w-4 h-4 mt-0.5 shrink-0 ${a.severity === "high" ? "text-red-600" : "text-amber-600"}`} />
            <div>
              <span className="font-semibold text-stone-900">{a.label}</span>{" "}
              <span className="text-stone-700">
                {a.key === "panic" ? `on ${a.days} logged days in a row` : `${a.threshold} for ${a.days} logged days in a row (latest ${a.latest})`}
              </span>
              <div className="text-xs text-stone-600">{HINTS[a.key]}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
